import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'react-bootstrap';

// Actions
import {
  getCloudImageUrl,
  emptyImage,
  convertToRupiah,
  formatCurrency,
  formatCurrencyV2,
} from '../../../utils';

// Assets
import MinusButton from '../../../images/minus.png';
import PlusButton from '../../../images/bag-plus.png';
import CloseButton from '../../../images/bag-delete.png';
import { UserCurrencyInterface } from '../../../interface/reducers/auth';

const MinusButtonIcon: any = MinusButton;
const PlusButtonIcon: any = PlusButton;
const CloseButtonIcon: any = CloseButton;

interface size {
  US: string;
}

interface selectedVoucherCode {
  code: number;
}

interface sell {
  subsidy_price: string;
}

interface filteredAddOnProduct {
  img_url: string;
  displayName: string;
  description: string;
  name: string;
  price: string;
  isSelected: boolean;
  active: boolean;
  visible: string;
}

type LeftBagSectionProps = {
  checkoutProcess: string;
  productImage: string;
  _sell: sell;
  category: string;
  display_name: string;
  productCondition: string;
  etaText: string;
  isCashback: boolean;
  asking_price: string;
  buyNowPrice: string;
  shippingFee: string;
  _discount: number;
  _shippingFee: string;
  getLayananPrice: string;
  subsidy_price: string;
  totalAddOnProduct: string;
  totalPrice: string;
  _umbreEnabled: boolean;
  discount: 0 | string;
  size: size;
  _totalAddOnProduct: string;
  filteredAddOnProduct: Array<filteredAddOnProduct>;
  addOnSelected: Array<Object>;
  selectedVoucherCode: selectedVoucherCode;
  _handleAdditionalChange: (item: Object, isSelected: boolean) => void;
  _getLayananPrice: () => number | void;
  userCurrency: UserCurrencyInterface;
};

const LeftBagSection: React.FC<LeftBagSectionProps> = ({
  checkoutProcess,
  addOnSelected,
  productImage,
  category,
  display_name,
  size,
  productCondition,
  etaText,
  asking_price,
  buyNowPrice,
  filteredAddOnProduct,
  _umbreEnabled,
  getLayananPrice,
  shippingFee,
  _shippingFee,
  discount,
  subsidy_price,
  totalAddOnProduct,
  totalPrice,
  _discount,
  _sell,
  selectedVoucherCode,
  _totalAddOnProduct,
  _getLayananPrice,
  _handleAdditionalChange,
  userCurrency,
  isCashback,
}): JSX.Element => {
  const emptyImageUrl: any = emptyImage(category);

  const [isShowDesc, setIsShowDesc] = useState(null);
  const [isShowDescOnSelectedAddOn, setIsShowDescOnSelectedAddOn] =
    useState(null);
  const [isShowDescOnSummaryAddOn, setIsShowDescOnSummaryAddOn] =
    useState(null);

  const handleShowDescription = (args) => {
    if (args === isShowDesc) {
      setIsShowDesc(null);
    } else {
      setIsShowDesc(args);
    }
  };

  const handleShowDescriptionOnSelectedAddon = (args) => {
    if (args === isShowDescOnSelectedAddOn) {
      setIsShowDescOnSelectedAddOn(null);
    } else {
      setIsShowDescOnSelectedAddOn(args);
    }
  };

  const handleShowDescriptionOnSummaryAddon = (args) => {
    if (args === isShowDescOnSummaryAddOn) {
      setIsShowDescOnSummaryAddOn(null);
    } else {
      setIsShowDescOnSummaryAddOn(args);
    }
  };

  return checkoutProcess === '' ? (
    <Col className="left-bag-content">
      <Row className="left-bag-top-section-shopping-bag">
        <Row className="shopping-bag-title-wrapper">
          <h3 className="left-bag-top-section-shopping-bag-title">
            Checkout Buy Now
          </h3>
        </Row>

        <Row className="shopping-bag-item-card-list-wrapper">
          {/* MAIN PRODUCT ITEM */}
          <Row
            className={`${
              addOnSelected.length > 0
                ? 'shopping-bag-item-card'
                : 'without-addon'
            }`}
          >
            <Row className="shopping-bag-item-wrapper">
              <Col className="shopping-bag-item-card-image-wrapper">
                {productImage ? (
                  <KickImage src={getCloudImageUrl(productImage, 500)} alt="..." />
                ) : (
                  <KickImage src={emptyImageUrl} alt="..." />
                )}
              </Col>
              <Col className="shopping-bag-item-card-description-wrapper">
                <p>{display_name}</p>
                <p>
                  {size.US} / {productCondition} / {etaText}{' '}
                </p>
                <p>
                  <span>{userCurrency.currency || 'IDR'}</span>

                  {formatCurrencyV2(
                    parseInt(buyNowPrice),
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Col>
            </Row>
          </Row>

          <div className="selected-addon-wrapper">
            {/* ADD ONS ITEM */}
            {filteredAddOnProduct.length > 0 &&
              filteredAddOnProduct
                .filter((item) => item.isSelected)
                .map((item, index) => {
                  const { img_url, displayName, description, price } = item;
                  const removeBrDescription = (() => {
                    const splitted = description
                      ? description.split('<br>')
                      : [];
                    return splitted[1]
                      ? `${splitted[0]}${splitted[1]}`
                      : description;
                  })();
                  return (
                    <div className="addon-item-card">
                      <KickImage
                        onClick={() => {
                          _handleAdditionalChange(item, !item.isSelected);
                        }}
                        src={CloseButtonIcon}
                        alt="..."
                        className="delete-addon"
                      />
                      <div className="addon-item-wrapper">
                        <div className="addon-image-wrapper">
                          {img_url ? (
                            <KickImage src={img_url} alt="..." />
                          ) : (
                            <KickImage
                              src={emptyImageUrl}
                              className="empty-img-addon"
                              alt="..."
                            />
                          )}
                        </div>
                        <div
                          className="addon-description-wrapper"
                          onClick={() =>
                            handleShowDescriptionOnSelectedAddon(index)
                          }
                        >
                          <div className="top-description">
                            <p>{displayName}</p>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: removeBrDescription,
                              }}
                              className={`umbre-description-text ${
                                removeBrDescription ? '' : 'remove-after'
                              } ${
                                isShowDescOnSelectedAddOn === index
                                  ? 'show'
                                  : ''
                              }`}
                            />
                          </div>
                          <p className="price">
                            <span>{userCurrency.currency || 'IDR'}</span>

                            {formatCurrencyV2(
                              price,
                              userCurrency.ratio,
                              userCurrency.currency,
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
        </Row>
      </Row>
      {filteredAddOnProduct.filter((item) => {
        if (
          item.active &&
          (item.visible === '*' || item.visible.includes(category)) &&
          !item.isSelected
        )
          return item;
      }).length !== 0 && (
        <Row className="left-bag-bottom-section-extra-item">
          <Row className="extra-item-shopping-bag-title-wrapper">
            <h3 className="left-bag-bottom-section-shopping-bag-title">
              Extra love for your purchase
            </h3>
          </Row>
          <Row className="extra-love-item-card-list-wrapper">
            {filteredAddOnProduct
              .filter((item) => {
                if (
                  item.active &&
                  (item.visible === '*' || item.visible.includes(category)) &&
                  !item.isSelected
                )
                  return item;
              })
              .map((item, index) => {
                const { img_url, displayName, description, price } = item;
                let disable =
                  item.name &&
                  item.name.toUpperCase() === 'KAXUMBRE' &&
                  !_umbreEnabled;

                const removeBrDescription = (() => {
                  const splitted = description ? description.split('<br>') : [];

                  if (splitted.length === 0) return description;

                  return splitted[1]
                    ? `${splitted[0]}${splitted[1]}`
                    : description;
                })();
                return (
                  <Col className="extra-love-item-card">
                    <Col className="shopping-cart-extra-item-image-wrapper">
                      {img_url ? <KickImage src={img_url} alt="..." /> : null}
                    </Col>
                    <Col className="extra-item-card-description">
                      <div
                        className={`display-name-wrapper`}
                        onClick={() => handleShowDescription(index)}
                      >
                        <p>{displayName}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: removeBrDescription,
                          }}
                          className={`umbre-description-text ${
                            removeBrDescription ? '' : 'remove-after'
                          } ${removeBrDescription ? '' : 'remove-after'} ${
                            isShowDesc === index ? 'show' : ''
                          }`}
                        />
                      </div>
                      <div className="price-wrapper">
                        <p className="price">
                          <span>{userCurrency.currency || 'IDR'}</span>

                          {formatCurrencyV2(
                            parseInt(price),
                            userCurrency.ratio,
                            userCurrency.currency,
                          )}
                        </p>
                        <KickImage
                          onClick={() => {
                            !disable
                              ? _handleAdditionalChange(item, !item.isSelected)
                              : null;
                          }}
                          className="extra-item-add-button-icon"
                          src={PlusButtonIcon}
                          alt="..."
                        />
                      </div>
                    </Col>
                  </Col>
                );
              })}
          </Row>
        </Row>
      )}
    </Col>
  ) : (
    <Col className="left-bag-content">
      <div className="scroll-wrapper">
        <Row className="left-bag-top-section-shopping-bag">
          <Row className="shopping-bag-title-wrapper">
            <h3 className="left-bag-top-section-shopping-bag-title">
              Order Details
            </h3>
          </Row>
          <Row className="shopping-bag-item-card-list-wrapper">
            {/* MAIN PRODUCT ITEM */}
            <Row className="shopping-bag-item-card">
              <Row className="shopping-bag-item-wrapper">
                <Col className="shopping-bag-item-card-image-wrapper">
                  {productImage ? (
                    <KickImage src={getCloudImageUrl(productImage, 500)} alt="..." />
                  ) : (
                    <KickImage src={emptyImageUrl} alt="..." />
                  )}
                </Col>
                <Col className="shopping-bag-item-card-description-wrapper">
                  <div className="desc-wrapper">
                    <p>{display_name}</p>
                    <p>
                      {size.US} / {productCondition} / {etaText}{' '}
                    </p>
                  </div>
                  <div className="price-quantity-wrapper">
                    <p>
                      <span>{userCurrency.currency || 'IDR'}</span>

                      {formatCurrencyV2(
                        parseInt(buyNowPrice),
                        userCurrency.ratio,
                        userCurrency.currency,
                      )}
                    </p>
                    <p>Qty: 1</p>
                  </div>
                </Col>
              </Row>
            </Row>

            <div className="selected-addon-wrapper">
              {/* ADD ONS ITEM */}
              {filteredAddOnProduct.length > 0 &&
                filteredAddOnProduct
                  .filter((item) => item.isSelected)
                  .map((item, index) => {
                    const { img_url, displayName, description, price } = item;
                    const removeBrDescription = (() => {
                      const splitted = description
                        ? description.split('<br>')
                        : [];
                      return splitted[1]
                        ? `${splitted[0]}${splitted[1]}`
                        : description;
                    })();
                    return (
                      <div className="addon-item-card">
                        <div className="addon-item-wrapper">
                          <div className="addon-image-wrapper">
                            {img_url ? (
                              <KickImage src={img_url} alt="..." />
                            ) : (
                              <KickImage
                                src={emptyImageUrl}
                                className="empty-img-addon"
                                alt="..."
                              />
                            )}
                          </div>
                          <div className="addon-description-wrapper">
                            <div
                              className="top-description"
                              onClick={() =>
                                handleShowDescriptionOnSummaryAddon(index)
                              }
                            >
                              <p>{displayName}</p>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: removeBrDescription,
                                }}
                                className={`umbre-description-text ${
                                  removeBrDescription ? '' : 'remove-after'
                                }  ${
                                  isShowDescOnSummaryAddOn === index
                                    ? 'show'
                                    : ''
                                }`}
                              />
                            </div>
                            <div className="bottom-description">
                              <p>
                                <span>{userCurrency.currency || 'IDR'}</span>

                                {formatCurrencyV2(
                                  price,
                                  userCurrency.ratio,
                                  userCurrency.currency,
                                )}
                              </p>
                              <p>Qty: 1</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </Row>
        </Row>
        <Row className="left-bag-bottom-section-extra-item summary-left-content">
          <Row className="right-bag-content-section-wrapper right-bag-summary-wrapper">
            <Row className="summary-title right-bag-content-summary-row">
              <p>Payment Summary</p>
            </Row>
            <Row className="right-bag-content-summary-row">
              <p>Product Price</p>
              <p>
                <span>{userCurrency.currency || 'IDR'}</span>

                {formatCurrencyV2(
                  parseInt(asking_price),
                  userCurrency.ratio,
                  userCurrency.currency,
                )}
              </p>
            </Row>
            {_getLayananPrice() > 0 && (
              <Row className="layanan-price right-bag-content-summary-row">
                <p>Administration Fee</p>
                <p>
                  <span>{userCurrency.currency || 'IDR'}</span>

                  {formatCurrencyV2(
                    getLayananPrice,
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Row>
            )}
            {parseInt(_shippingFee) > 0 && (
              <Row className="shipping-fee right-bag-content-summary-row">
                <p>Shipping &#38; Handling</p>
                <p>
                  <span>{userCurrency.currency || 'IDR'}</span>

                  {formatCurrencyV2(
                    shippingFee,
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Row>
            )}
            {selectedVoucherCode && _discount && (
              <Row className="discount right-bag-content-summary-row">
                <p>{isCashback ? 'Potential Cashback' : 'Voucher Code'}</p>
                <p className={`${isCashback ? 'cashback' : ''}`}>
                  <span>
                    {discount ? (isCashback ? '' : '-') : ''}{' '}
                    {userCurrency.currency}
                  </span>

                  {formatCurrencyV2(
                    discount,
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Row>
            )}
            {parseInt(_sell.subsidy_price) > 0 && (
              <Row className="subsidy-price right-bag-content-summary-row">
                <p>
                  Discount &#40;<span>Automatically applied</span>&#41;
                </p>
                <p>
                  <span>{userCurrency.currency || 'IDR'}</span>

                  {formatCurrencyV2(
                    subsidy_price,
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Row>
            )}
            {parseInt(_totalAddOnProduct) > 0 && (
              <Row className="total-addon-price right-bag-content-summary-row">
                <p>Promo Product</p>
                <p>
                  <span>{userCurrency.currency || 'IDR'}</span>

                  {formatCurrencyV2(
                    totalAddOnProduct,
                    userCurrency.ratio,
                    userCurrency.currency,
                  )}
                </p>
              </Row>
            )}
            <Row className="total-price right-bag-content-summary-row">
              <p>Total</p>
              <p>
                <span>{userCurrency.currency || 'IDR'}</span>

                {formatCurrencyV2(
                  totalPrice,
                  userCurrency.ratio,
                  userCurrency.currency,
                )}
              </p>
            </Row>
          </Row>
        </Row>
      </div>
    </Col>
  );
};

export default LeftBagSection;
